import { format } from '@/utils/StringUtilities'

// 2) V ramci jednoho datasetu musi byt dvojice (InstitutionId, ReportTemplateId) pouze jednou
const validateInstitutionReportTemplateUniqueness = (datasets, errorMessageFormat, locale) => {
  if (datasets && datasets.length > 0) {
    for (let x = 0; x < datasets.length; x++) {
      const dataset = datasets[x]

      const existingCombinations = []
      for (let y = 0; y < dataset.reportSubmissionGroups.length; y++) {
        const reportSubmissionGroup = dataset.reportSubmissionGroups[y]

        const { institutionId, institutionName, institutionLatinName } = reportSubmissionGroup

        for (let i = 0; i < reportSubmissionGroup.reportTemplates.length; i++) {
          const template = reportSubmissionGroup.reportTemplates[i]

          const key = `${institutionId}_${template.code}`
          if (existingCombinations.indexOf(key) === -1) {
            existingCombinations.push(key)
          } else {
            return format(
              errorMessageFormat,
              (locale === 'ar' ? template.name : template.latinName),
              (locale === 'ar' ? institutionName : institutionLatinName),
              dataset.index === null ? '' : dataset.index
            )
          }
        }
      }
    }
  }
  return null
}

export {
  validateInstitutionReportTemplateUniqueness
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/outputReportGenerator/validation/validateInstitutionReportTemplateUniqueness.js